<template>
	<div ng-controller="inviteFriendCtrl" class="inviteFriend">
		<div>
			<nav class="tabulation maintab unselectable">
				<a id="optimizely_maintab_InviteFriend" class="tab clickable" :class="{'active': tab == 'tab1', 'inactive': tab != 'tab1'}" @click="onToggleTab('tab1')">
					<div class="content">
						<span>Пригласить друга</span>
					</div>
				</a>
				<a id="optimizely_maintab_InvitationOverview" class="tab clickable" :class="{'active': tab == 'tab2', 'inactive': tab != 'tab2'}" @click="onToggleTab('tab2')">
					<div class="content">
						<span>Обзор приглашений</span>
					</div>
				</a>
			</nav>
			<div class="tabulationContent scrollable scrollingDisabled tabContentInviteFriend">
				<div class="scrollContentOuterWrapper disableScrolling">
					<div class="scrollContent disableScrolling">
						<div class="scrollContentInnerWrapper" style="width: auto;">
							<div ng-transclude="">
								<div class="loadedTab currentTab tabInviteFriend" v-if="tab == 'tab1'">
									<div class="contentBox gradient referralRewards">
										<div class="contentBoxHeader">
											<span class="content"><span>Награды</span></span>
										</div>
										<div class="contentBoxBody">
											<div class="header"><span>Приглашай новых игроков в Travian Kingdoms и получай награду!</span></div>
											<div class="reward">
												<i class="rewardIcon inviteFriend_secondVillage_small_flat_black"></i>
												<span class="text" data="gold: 20"><span>Когда игрок поставит </span><strong>вторую деревню</strong><span>, ты получишь </span><i class="icon unit_gold_small_illu"></i> <strong>20</strong><span>.</span></span>
											</div>
											<div class="reward">
												<i class="rewardIcon inviteFriend_thirdVillage_medium_flat_black"></i>
												<span class="text" data="gold: 30"><span>Когда игрок поставит </span><strong>третью деревню</strong><span>, ты получишь </span><i class="icon unit_gold_small_illu"></i> <strong>30</strong><span>.</span></span>
											</div>
											<div class="reward">
												<i class="rewardIcon inviteFriend_firstPayment_small_flat_black"></i>
												<span class="text" data="gold: 50"><span>Когда игрок впервые </span><strong>приобретет золото</strong><span>, ты получишь </span><i class="icon unit_gold_small_illu"></i> <strong>50</strong><span>.</span></span>
											</div>
											<div class="reward">
												<i class="rewardIcon inviteFriend_prestigeCup_small_flat_black"></i>
												<span class="text" data="gold: 100"><span>Когда игрок наберет </span><strong>1000 престижа</strong><span>, ты получишь </span><i class="icon unit_gold_small_illu"></i> <strong>100</strong><span>. </span><br><span>(возможно в одном или нескольких раундах).</span></span>
											</div>
										</div>
									</div>
									<div style="display: flex; justify-content: space-evenly;">
										<div class="contentBox inviteBox giftBox gradient">
											<div class="contentBoxHeader goldenEnding headerWithArrowEndings">
												<div class="content"><span>Подарок</span></div>
											</div>
											<div class="contentBoxBody">
												<div class="spacer"></div>
												<i class="inviteFriend_invitationGift_large_illu"></i>
												<span><span>В качестве подарка от нас твои друзья получат </span><i class="icon unit_gold_small_illu"></i> <strong>50</strong><span> и </span><strong>Travian Plus на 7 дней</strong><span> после активации.</span><br/><br/><span>Это поможет им развиться быстрее.</span></span>
											</div>
										</div>
										<div class="contentBox inviteBox emailBox">
											<div class="contentBox gradient">
												<div class="contentBoxBody">
													<div class="header"><span>Пригласить по e-mail</span></div>
													<div class="inviteInfo"><span>Нажми на кнопку внизу, чтобы пригласить друзей по e-mail.</span></div>
												</div>
											</div>
											<div class="inviteButton">
												<button ng-click="openSendEmailOverlay()">
													<div class="content">
														<span ng-transclude="" class="innerText">
															<span><span>Пригласить по e-mail</span></span>
														</span>
														<!-- ngIf: price > 0 || forceGoldUsage -->
														<!-- ngIf: price == -1 && !forceGoldUsage -->
														<div class="animationOverlay"></div>
														<i class="checkmark action_check_small_flat_white"></i>
														<i class="checkmark action_check_small_flat_black"></i>
														<i class="checkmark action_check_small_flat_red"></i>
													</div>
												</button>
											</div>
										</div>
										<div class="contentBox inviteBox referralLinkBox">
											<div class="contentBox gradient">
												<div class="contentBoxBody">
													<div class="header"><span>Пригласить с помощью реф-ссылки</span></div>
													<div class="inviteInfo"><a href="http://www.kingdoms.com/ru/#action=register;referral=V6773605" target="_blank"><span>Реф-ссылка</span></a></div>
												</div>
											</div>
											<div class="inviteButton">
												<button ng-click="copyLink()">
													<div class="content">
														<span ng-transclude="" class="innerText">
															<span><span>Скопировать</span></span>
														</span>
														<!-- ngIf: price > 0 || forceGoldUsage -->
														<!-- ngIf: price == -1 && !forceGoldUsage -->
														<div class="animationOverlay"></div>
														<i class="checkmark action_check_small_flat_white"></i>
														<i class="checkmark action_check_small_flat_black"></i>
														<i class="checkmark action_check_small_flat_red"></i>
													</div>
												</button>
											</div>
										</div>
									</div>
								</div>
								<div class="loadedTab currentTab tabInvitationOverview" v-if="tab == 'tab2'">
									<div class="friendInvitations">
										<div class="contentBox gradient accepted">
											<div class="contentBoxHeader">
												<span class="content"><span>Принятые приглашения</span></span> (0)
											</div>
											<div scrollable="" class="contentBoxBody scrollable">
												<div class="scrollContentOuterWrapper">
													<div class="scrollContent" style="overflow-y: auto;">
														<div class="scrollContentInnerWrapper" style="width: auto;">
															<table class="transparent ng-hide" ng-show="invitations.accepted.length > 0">
																<thead>
																	<tr>
																		<th><span>Имя персонажа</span></th>
																		<th><i class="rewardIcon inviteFriend_secondVillage_small_flat_black"></i></th>
																		<th><i class="rewardIcon inviteFriend_thirdVillage_medium_flat_black"></i></th>
																		<th><i class="rewardIcon inviteFriend_firstPayment_small_flat_black"></i></th>
																		<th><i class="inviteFriend_prestigeCup_small_flat_black"></i></th>
																		<th></th>
																	</tr>
																</thead>
																<tbody>
																	<!-- ngRepeat: invitation in invitations.accepted | orderBy:'collectibleAmount':true -->
																</tbody>
															</table>
															<p ng-show="invitations.accepted.length === 0">
																<span>В данный момент у тебя нет принятых приглашений. Приглашенные игроки должны активировать свои учетные записи, прежде чем ты сможешь получить какую-либо награду.</span>
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="contentBox gradient open">
											<div class="contentBoxHeader">
												<span class="content"><span>Открытые приглашения</span></span> (1)
											</div>
											<div scrollable="" class="contentBoxBody scrollable">
												<div class="scrollContentOuterWrapper">
													<div class="scrollContent" style="overflow-y: auto;">
														<div class="scrollContentInnerWrapper" style="width: auto;">
															<table class="transparent" ng-show="invitations.open.length > 0">
																<tbody>
																	<tr ng-repeat="invitation in invitations.open">
																		<td>alexens3011@mail.ru<span class="rightBorder"></span></td>
																		<td><span i18ndt="1722592574" format="mediumDate">02.08.2024</span></td>
																	</tr>
																</tbody>
															</table>
															<p ng-show="invitations.open.length === 0">
																<span>В данный момент у тебя нет открытых приглашений.</span>
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		tab: 'tab1',
	}),
	computed: {},
	methods: {
		onToggleTab(tab){
			this.tab = tab;
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
	},
	components: {},
}
</script>